export default __webpack_public_path__ + "static/media/ITRealCase3-moblie-en.61c58bba.jpg";